<template>
    <div>
        <ob1-text-field
            v-model="inputImei"
            input-id="recovery-simulator-imei"
            :max-length="15"
            :input-label="messages.imeiLabel"
            :helper-text-label="messages.imeiHelper"
            :is-invalid="imeiInvalid"
            :error-label="imeiErrorMessage"
            type-value="number"
            @ob1-text-field-input="onSelectImei"
            @ob1-text-field-blur="onBlurImei"
        />
        <div>
            <ob1-select-field
                id="recovery-simulator-brands"
                v-model="selectedBrand"
                :elements="brands"
                :place-holder="messages.brandLabel"
                :disabled="selectedImei === undefined || loadingBrand"
                @input="onSelectBrand"
            />
            <ob1-progress-indicators v-if="loadingBrand" :size="25" type="undetermined" />
        </div>
        <div>
            <ob1-select-field
                id="recovery-simulator-models"
                v-model="selectedModel"
                :elements="models"
                :disabled="selectedImei === undefined || selectedBrand === undefined || loadingModel"
                :place-holder="messages.modelLabel"
                @input="onSelectModel"
            />
            <ob1-progress-indicators v-if="loadingModel" :size="25" type="undetermined" />
        </div>
    </div>
</template>

<script>
export default {
    name: "RecoverySimulatorByImei",
    props: {
        shop: {
            type: String,
            required: true
        },
        messages: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            inputImei: undefined,
            imeiInvalid: false,
            imeiErrorMessage: this.messages.imeiError,
            selectedImei: undefined,
            selectedBrand: undefined,
            selectedModel: undefined,
            brandsAndModels: [],
            brands: [],
            models: [],
            loadingBrand: false,
            loadingModel: false,

        }
    },
    computed: {
    },
    mounted: function () {
    },
    methods: {
        onSelectBrand() {
            this.selectedModel = undefined;
            this.loadingModel = true;
            let brand = this.brandsAndModels.find(brand => brand.label === this.selectedBrand)
            this.loadingModel = false;
            if (brand){
                this.models = brand.models;
                if (this.models.length === 1){
                    this.selectedModel = this.models[0];
                }
                this.$emit('selectModel', this.selectedBrand, this.selectedModel);
            } else {
                this.models = [];
                this.$emit('error');
            }
        },
        onSelectModel(){
            this.$emit('selectModel', this.selectedBrand, this.selectedModel);
        },
        onSelectImei(value) {
            if (value.length === 15 && !isNaN(value)) {
                this.imeiInvalid = false;
                this.selectedImei = value;
                this.selectedBrand = undefined;
                this.selectedModel = undefined;
                this.loadingBrand = true;
                this.fetchModelsByImei(this.shop, this.selectedImei).then(result => {
                    this.brandsAndModels = result.brands;
                    this.brands = result.brands.map(brand => brand.label);
                    this.loadingBrand = false;
                    if (result.brands.length === 1) {
                        this.selectedBrand = result.brands[0].label;
                        this.models = result.brands[0].models;
                        if (this.models.length === 1) {
                            this.selectedModel = this.models[0];
                        }
                    }
                    this.$emit('selectModel', this.selectedBrand, this.selectedModel);
                }).catch(() => {
                    this.brandsAndModels = [];
                    this.brands = [];
                    this.models = [];
                    this.$emit('error');
                }).finally(() => {
                        this.loadingBrand = false;
                    }
                )
            } else if (value.length > 15 || (value.length > 1 && isNaN(value))){
                this.imeiInvalid = true;
                this.reset();
            } else {
                this.reset();
            }
        },
        reset(){
            this.selectedImei = undefined;
            this.selectedBrand = undefined;
            this.selectedModel = undefined;
            this.brands = [];
            this.models = [];
        },
        onBlurImei(){
            if (this.selectedImei === undefined){
                this.imeiInvalid = true;
            }
        },
        fetchModelsByImei: function (shop, imei) {
            let url = "/api/recovery/imei"
            return new Promise((resolve, reject) => {
                $.ajax({
                    method: "GET",
                    data: {
                        "shop": shop,
                        "imei": imei
                    },
                    url: url,
                    contentType: "application/json",
                    dataType: "json"
                }).done(result => {
                    resolve(result)
                }).fail(error => {
                    reject(error)
                })
            });
        },
    }
}
</script>

<style lang="scss">

</style>
